import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FiservWebhookAddAccountComponent } from './add-account/fiserv-webhook.component';
import { FiservWebhookErrorResolutionComponent } from './error-resolution/fiserv-webhook.component';

const routes: Routes = [
    { path: 'addaccounts/:userId/:enrollmentId/success', component: FiservWebhookAddAccountComponent },
    { path: 'addaccounts/:userId/:enrollmentId/failure', component: FiservWebhookAddAccountComponent },
    { path: 'errorresolution/:userId/:enrollmentId/success', component: FiservWebhookErrorResolutionComponent },
    { path: 'errorresolution/:userId/:enrollmentId/failure', component: FiservWebhookErrorResolutionComponent },
    { path: '', pathMatch: 'full', redirectTo: 'errorresolution/:userId/:enrollmentId/failure' }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class FiservWebhooksRoutingModule { }
